import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const removeFileAPI = async (
  id,
  s3Path,
  t,
  successText,
  setRefreshCapacity,
  onClose,
  reloadTable
) => {
  await axios({
    url: `/api/v2/drive/file/delete`,
    method: "DELETE",
    data: {
      id: id,
      s3_path: s3Path
    }
  });
  successHandling(t, successText);
  setRefreshCapacity(true);
  onClose();
  reloadTable();
  return true;
};
